import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';
import { TypeUserRecord } from '@/lib/api/accountManager/types';

export type GetUserParams = {
  userUuid: string;
  authToken?: string;
};

export async function getUser(params: GetUserParams) {
  const { userUuid, authToken } = params;

  if (!userUuid) {
    console.warn('[getUser]: Missing Required Params');
  }

  const config = {
    method: 'GET',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
    },
  };

  const response = await fetch(
    `${API_URLS.ACCOUNT_MANAGER}users/${userUuid}`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypeUserRecord>;
}
